import { render, staticRenderFns } from "./ManualIcon.vue?vue&type=template&id=01fd7afe&scoped=true&"
import script from "./ManualIcon.vue?vue&type=script&lang=js&"
export * from "./ManualIcon.vue?vue&type=script&lang=js&"
import style0 from "./ManualIcon.vue?vue&type=style&index=0&id=01fd7afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd7afe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
